<template>
  <div
    class="popup popup-rule"
    :class="{ 'modal-in': isShow, 'modal-out': !isShow }"
    style="display: block"
    id="bookingRule"
  >
    <div class="shorexDetail-title js-returnShorexBtn">
      <p>预订政策</p>
      <a class="shorexDetail-returnButton" @click="onGoBack()">
        <img
          src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png"
        />
      </a>
    </div>
    <PolicyContent
      :visaContent="visaContent"
      :departureCode="departureCode"
      :isFortyEightHoursNrpCruise="isFortyEightHoursNrpCruise"
      :isSevenDayNrpCruise="isSevenDayNrpCruise"
      :showBankPopup="showBankPopup"
      :currentTab="currentTab"
      :customClass="'cruiseDetail'"
      :isShowSpecialBooking="isShowSpecialBooking"
      :shipCode="shipCode"
      :sailDate="sailDate"
      :isDownPayCruise="isDownPayCruise"
      :showRow="showRow"
    />
  </div>
</template>

<script>

const PolicyContent = () => import("@/components/Cruise/PolicyContent");

export default {
  name: "BookingPolicyPopup",
  components: {
    PolicyContent,
  },
  props: {
    isShow: {
      type: Boolean,
      default() {
        return false;
      },
    },
    onGoBack: {
      type: Function,
    },
    currentTab: {
      type: Number,
      default() {
        return -1;
      },
    },
    visaContent: {
      type: Object,
      default() {
        return {
          visaContent: "",
          hkGuestContent: "",
          insuranceContent: "",
        };
      },
    },
    departureCode: {
      type: String,
    },
    isFortyEightHoursNrpCruise: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isSevenDayNrpCruise: {
      type: Boolean,
      default() {
        return false;
      },
    },
    showBankPopup: {
      type: Function,
    },
    isShowSpecialBooking: {
      type: Boolean,
      default() {
        return false;
      },
    },
    shipCode: {
      type: String,
      default() {
        return true;
      },
    },
    sailDate: {
      type: String
    },
    isDownPayCruise: {
      type: Boolean,
      default() {
        return false;
      }
    },
    showRow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {

    }
  },
  mounted() {
  },
  methods: {
    goBack() {
      this.onGoBack();
    },
  },
};
</script>

<style lang="less" scoped>
#bookingRule.popup {
  position: fixed;
  background-color: #f6f7f8;
  transform: translate3d(100%, 0, 0);
  display: block;
  z-index: 10401;
}
#bookingRule.modal-in {
  position: fixed;
  background-color: #f6f7f8;
  transform: translate3d(0, 0, 0);
}
#bookingRule.modal-out {
  transform: translate3d(100%, 0, 0);
}

#bookingRule {
  .shorexDetail-title {
    padding: 15px 20px;
    background-color: #fff;
    overflow: hidden;
    text-align: center;
    margin-bottom: 10px;
    position: fixed;
    width: 100%;
    z-index: 10;
    > p {
      font-family: PingFang-SC-Medium;
      font-size: 14px;
      color: #333333;
      letter-spacing: 1px;
      text-align: center;
      margin: 0;
    }
    .shorexDetail-returnButton {
      width: 30px;
      position: absolute;
      top: 15px;
      left: 20px;
      text-align: left;
      > img {
        width: 33%;
      }
    }
  }
}
</style>
